exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".folder-tree li{background:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/CaseFolder/Integrations/iManage/IManageWorkspaceFolderSelector.less
// module id = 1586
// module chunks = 0